import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';
import { CultureTextModel } from '../form';

export interface NumericFieldModel extends BaseFieldModel {
  defaultValue: number | undefined;
  placeholder: CultureTextModel[] | string;
  min: number | undefined;
  max: number | undefined;
  decimals: number | undefined;
  type: FieldType.Numeric;
}

export class NumericField extends BaseField implements NumericFieldModel {
  public defaultValue: number | undefined;
  public placeholder: CultureTextModel[] | string = '';
  public min: number | undefined;
  public max: number | undefined;
  public decimals: number | undefined;
  public type: FieldType.Numeric = FieldType.Numeric;

  constructor(cultures: string[]) {
    super(FieldType.Numeric, cultures);

    this.initialize();

    this.placeholder = [];

    for (const culture of cultures) {
      this.placeholder.push({ culture, value: '' });
    }
  }

  private initialize = () => {
    this.max = 50;
  };
}
